export default "__VITE_ASSET__CYd4L0do__"